var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlayHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#06255C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 66.3157C56.7727 66.3157 66.3161 56.7723 66.3161 44.9999C66.3161 33.2275 56.7727 23.6841 45.0004 23.6841C33.228 23.6841 23.6846 33.2275 23.6846 44.9999C23.6846 56.7723 33.228 66.3157 45.0004 66.3157Z",
    stroke: "white",
    strokeWidth: 3.55263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6714 38.5312C39.6714 37.5139 39.6714 37.0052 39.884 36.7212C40.0693 36.4737 40.3529 36.3189 40.6613 36.2969C41.0151 36.2716 41.443 36.5467 42.2988 37.0968L52.3611 43.5654C53.1037 44.0428 53.475 44.2815 53.6033 44.585C53.7153 44.8502 53.7153 45.1495 53.6033 45.4147C53.475 45.7182 53.1037 45.9569 52.3611 46.4343L42.2988 52.9029C41.443 53.4531 41.0151 53.7282 40.6613 53.7029C40.3529 53.6809 40.0693 53.526 39.884 53.2785C39.6714 52.9946 39.6714 52.4859 39.6714 51.4685V38.5312Z",
    stroke: "white",
    strokeWidth: 3.55263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlayHover);
export default __webpack_public_path__ + "static/media/circle-play-hover.c7a70b4163fd607ea5955ee2c65e9873.svg";
export { ForwardRef as ReactComponent };